import { combineReducers } from '@reduxjs/toolkit';

import { company } from './core/company';
import { companyList } from './core/companyList';
import { advertsList } from './core/advertsList';

import { checkautoCompanyAllList } from './all/checkautoCompanyAllList';
import { companyAll } from './all/companyAll';
import { companyAllList } from './all/companyAllList';

export default combineReducers({
    company,
    companyList,
    advertsList,
    companyAll,
    companyAllList,
    checkautoCompanyAllList,
});
